import React from "react"

import {
    Avatar,
    Box,
    Button,
    Dialog,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Stack, TextField,
    Typography,
} from "@mui/material"

import {t, Trans} from "@lingui/macro"

import {AssignableUsers, Template, WorkflowUtils} from "models"
import {SbDialog} from "../../commons/sb-dialog";
import Icon from "@mdi/react";
import {Autocomplete} from "@mui/lab";
import AssignComponent from "./assign-component";

interface OptionsType
{
    id: string,
    name: string
}

interface AssignTemplateProp {
    openDialog: boolean
    onClose: () => void
    onAssign: (templateId: string, userId: string) => void
    data: Template
    users: AssignableUsers[]
}

interface  AssignTemplateState {
    personSelected: string
}

export class AssignTemplate extends React.Component<AssignTemplateProp, AssignTemplateState>
{
    constructor(props: AssignTemplateProp) {
        super(props)
        this.state = {
            personSelected: ""
        }
    }

    private onClose = () => {
        this.setState(() => ({
            personSelected: ""
        }))
        this.props.onClose()
    }

    private assign = () => {
        if(this.state.personSelected){
            this.props.onAssign(this.props.data.id, this.state.personSelected)
        }
    }

    private setSelection = (id: string) => {
        this.setState(() => ({
            personSelected: id
        }))
    }

    render() {

        return (
            <>
                {
                    this.props.openDialog &&
                    <SbDialog onClose={this.onClose}
                              width={"md"}
                              titleText={t({id: "workflow.assign-template.title", message: "Assegna template workflow"})}
                              confirmButton
                              onConfirm={this.assign}
                    >
                        <AssignComponent data={this.props.data} users={this.props.users} selectionCallback={this.setSelection} />
                    </SbDialog>
                }
            </>
        )
    }
}
